export default "__VITE_ASSET__B2qNNdM9__"